const Saga = (target) => {
  const sagaCards = target.querySelectorAll(".sagacard");
  const allCards = {};

  const method = {
    init: () => {
      document.addEventListener("scroll", method.onScroll);
      window.addEventListener("load", method.onScroll);
      window.addEventListener("resize", method.onScroll);

      sagaCards.forEach((el) => {
        const positions = el.getBoundingClientRect();
        allCards[positions.top] = el;
      });
    },
    onScroll: () => {
      const { scrollY } = window;
      Object.entries(allCards).forEach(([key, val]) => {
        const htmlEl = val as HTMLElement;
        const keyNum = parseInt(key, 10);

        if ((scrollY + 350) > keyNum) {
          htmlEl.classList.add("sagacard--dark");
        } else {
          htmlEl.classList.remove("sagacard--dark");
        }
      });
    },
  };

  method.init();
};

export default Saga;
